import { SUBSCRIPTION_STATUS } from "@fysaro/shared";
import { z } from "zod";

export const createCheckoutSchema = z.object({
  planId: z.string().uuid(),
  tenantId: z.string().uuid(),
  status: z.enum(SUBSCRIPTION_STATUS),
  stripeSubscriptionId:z.string().nullable(),
  stripeCustomerId:z.string().nullable(),
  currentPeriodEnd:z.string().nullable(),
  pendingCancelAtPeriodEnd:z.string().nullable(),
  activeConfig:z.string().nullable(),
  successUrl: z.string().url("URL inválida"), // URL a la que vuelve si paga (ej: /settings/billing?success=true)
  cancelUrl: z.string().url("URL inválida"), // URL si cierra el modal (ej: /settings/billing?cancel=true)
});
